'use strict';

document.addEventListener('wpcf7invalid', function () {
      document.querySelectorAll('.contact-form__itm').forEach(function(row){
            // 既存エラー削除
            const errorArea = row.querySelector('.contact-form__required-err');
            
            // errorAreaが存在し、テキストがある場合は削除
            if(errorArea && errorArea.textContent.trim() !== ''){
                  errorArea.textContent = '';
            }

            // CF7エラー取得
            setTimeout(function () {
                  const errors = row.querySelectorAll('.wpcf7-not-valid-tip');
                  if(errors.length && errorArea){
                        // 重複除去
                        const messages = [];
                        errors.forEach(function(error){
                              const text = "※"+error.textContent.trim();
                              if(text && !messages.includes(text)){
                                    messages.push(text);
                              }
                        });

                        // 表示
                        errorArea.innerHTML = messages.join('<br>');

                        // 元エラーを消す
                        errors.forEach(function(error){
                              error.remove();
                        });

                  }
            }, 100);
      });
}, false);